// src/email/AnnouncementEmail.js
// eslint-disable-next-line no-unused-vars
import React from "react";

const AnnouncementEmail = ({ subject, username, message, emailAddress }) => {
  return `
  <!DOCTYPE html>
  <html lang="en">
  <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Announcement Arcane Rappelz</title>
  </head>
  <body style="font-family: Arial, sans-serif; background-color: #f4f4f4; text-align: center; padding: 20px; color: #333;">
      <div style="max-width: 500px; background: #ffffff; padding: 20px; border-radius: 10px; box-shadow: 0px 4px 10px rgba(0,0,0,0.1); margin: auto; text-align: center;">
          <img src="https://arcane-rappelz.com/assets/logo/logo_big.png" alt="Arcane Logo" style="max-width: 200px; margin-bottom: 20px;">
          <h2>Important Announcement</h2>
          <h3>${subject}</h3>
          <p>Dear Arcane Rappelz ${username},</p>
          <div>${message}</div>
          <p>Stay tuned for more updates!</p>
      </div>
      <div style="margin-top: 20px; font-size: 12px; color: #808080; text-align: center; line-height: 1.5;">
          <p>This email was sent to: <strong>${emailAddress}</strong></p>
          <p>You are receiving this email because you registered on <a href="https://arcane-rappelz.com">Arcane Rappelz</a>.</p>
          <p>If you believe this is an error, please <a href="https://arcane-rappelz.com/support">contact our support team</a>.</p>
          <p>&copy; Arcane Rappelz 2025.</p>
          <p>Your security is our priority. <strong>Never share your password with anyone.</strong></p>
      </div>
  </body>
  </html>
  `;
};

export default AnnouncementEmail;
